// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ebe83c9a","455":"ba09b68b","977":"5e7cabed"}[chunkId] + ".chunk.js";
};